import React, { useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useApi } from "../../utils/Api";
import Translate from "../../utils/Translate";
import Box from "@mui/material/Box";

export default function FinalExamUnlockedSelect({ setIsLoading, showLockFromExercise }) {
  const [finalExamUnlocked, setFinalExamUnlocked] = React.useState(false);
  const [finalExamLockFromExerciseResults, setFinalExamLockFromExerciseResults] = React.useState(null);
  const api = useApi();

  useEffect(() => {
    async function init() {
      setIsLoading(true);
      const [response1, response2] = await Promise.all([
        api.fetch(`${import.meta.env.VITE_MAIN_URL}dataIdSettings/finalExamUnlocked`, false, "GET"),
        api.fetch(`${import.meta.env.VITE_MAIN_URL}dataIdSettings/finalExamLockFromExerciseResults`, false, "GET"),
      ]);

      if (response1.isSuccessful) {
        setFinalExamUnlocked(response1.settingValue === "True");
      }
      if (response2.isSuccessful) {
        setFinalExamLockFromExerciseResults(response2.settingValue);
      }

      setIsLoading(false);
    }

    init();
  }, [api, setIsLoading]);

  async function handleChangeFinalExamUnlocked(newValue) {
    setFinalExamUnlocked(newValue);
    await postFinalExamUnlockedState(newValue);
  }

  async function postFinalExamUnlockedState(value) {
    setIsLoading(true);
    const request = { settingValue: value };
    await api.fetch(
      `${import.meta.env.VITE_MAIN_URL}dataIdSettings/setFinalExamUnlocked`,
      request,
      "POST",
      false,
      true,
    );
    setIsLoading(false);
  }

  async function handleChangeFinalExamLockFromExerciseResults(newValue) {
    setFinalExamLockFromExerciseResults(newValue);
    await postFinalExamLockFromExerciseResults(newValue);
  }

  async function postFinalExamLockFromExerciseResults(value) {
    setIsLoading(true);
    const request = { settingValue: value };
    await api.fetch(
      `${import.meta.env.VITE_MAIN_URL}dataIdSettings/setFinalExamLockFromExerciseResults`,
      request,
      "POST",
      false,
      true,
    );
    setIsLoading(false);
  }

  return (
    <>
      <p>{Translate.get("AsStandardFinalExam")}</p>
      <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={finalExamUnlocked}
            onChange={(ev) => handleChangeFinalExamUnlocked(ev.target.value)}
          >
            <MenuItem value={true}>{Translate.get("Open")}</MenuItem>
            <MenuItem value={false}>{Translate.get("LockedState")}</MenuItem>
          </Select>
        </FormControl>
      </Box>
      {showLockFromExercise && (
        <>
          <p>{Translate.get("LockFinalExamOnExerciseResultsBelow")}</p>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth disabled={!finalExamUnlocked}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={finalExamLockFromExerciseResults ?? "Never"}
                onChange={(ev) => handleChangeFinalExamLockFromExerciseResults(ev.target.value)}
              >
                <MenuItem value="Never">{Translate.get("Never")}</MenuItem>
                <MenuItem value="Below80Percent">80%</MenuItem>
                <MenuItem value="Below65Percent">65%</MenuItem>
                <MenuItem value="Below50Percent">50%</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </>
      )}
    </>
  );
}
